import React, { useEffect } from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

import Testimonials from "../Home/Testimonials";
import GetInTouch from "../Home/GetInTouch";
import WhyChooseUs from "../Home/WhyChooseUs";

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us - Mitra Recharge";
  }, []);

  return (
    <React.Fragment>
      <div class="page_wrapper">
        <Header headerType="white_header" />

        {/* breadcrumb area start */}
        <section className="nh_breadcrumb-area">
          <div
            className="nh_breadcrumb-wrap"
            data-background="assets/images/bg/breadcrumb.webp"
          >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7">
                  <div className="nh_breadcrumb-content text-center">
                    <h2 className="nh_breadcrumb-content-title">About Us</h2>
                    <div className="nh_breadcrumb-content-list">
                      <a href="/">Home</a>
                      <span>About Us</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <>
          {/* reason area end */}
          {/* about area start */}
          <section className="h2_nh_about-area pb-100 pt-100">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h3 className="appie-title">Who We Are</h3>
                  <p className="pt-2 text-justify">
                    Welcome to Mitra Recharge, your trusted partner for seamless
                    and instant recharge services. Operated by PANMITRA ONLINE
                    SERVICE PRIVATE LIMITED, we specialize in providing reliable
                    solutions for Mobile Recharge, DTH Recharge, and Google Play
                    Recharge, ensuring a smooth experience for our customers
                    across India.
                  </p>
                  <h4 className="pt-3">Our Vision</h4>
                  <p className="pt-2 text-justify">
                    To become a leading digital recharge platform in India,
                    empowering individuals and businesses with seamless, secure,
                    and rewarding recharge solutions for Mobile, DTH, and Google
                    Play services.
                  </p>
                  <h4 className="pt-3">Our Mission</h4>
                  <p className="pt-2 text-justify">
                    Our mission at Mitra Recharge is to provide fast, secure,
                    and reliable recharge services that empower individuals and
                    businesses. We strive to deliver a seamless experience while
                    ensuring customer satisfaction and business growth through
                    innovative solutions and excellent support.
                  </p>
                </div>
                <div className="col-md-6">
                  <div className="about-image pl-5">
                    <img
                      src="images/about-us.png"
                      className="about2"
                      alt="about"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* about area end */}
        </>
        <WhyChooseUs />
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default AboutUs;
